import React, { useState, useEffect } from 'react';
import './App.css';

function Navbar() {
  return (
    <nav className="navbar-matte-red">
      <div className="navbar-title">CAP Box</div>
    </nav>
  );
}

function App() {
  const [gyms, setGyms] = useState([]);
  const [editId, setEditId] = useState(null);
  const [form, setForm] = useState({
    nombre: '',
    tamano: 'pequeño',
    totalBoxeadores: '',
    ubicacion: '',
    logo: '',
  });
  const [logoPreview, setLogoPreview] = useState('');

  const API_URL = 'https://api.capbox.site/identity/v1/gyms';

  useEffect(() => {
    fetchGyms();
  }, []);

  const fetchGyms = async () => {
    try {
      const res = await fetch(API_URL);
      const data = await res.json();
      const adaptados = data.map((g) => ({
        id: g.id,
        nombre: g.name,
        tamano: g.size,
        totalBoxeadores: g.totalBoxers,
        ubicacion: g.location,
        logo: g.imageUrl,
      }));
      setGyms(adaptados);
    } catch (error) {
      console.error('Error al obtener gimnasios:', error);
    }
  };

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === 'logo' && files && files[0]) {
      const reader = new FileReader();
      reader.onload = (ev) => {
        setLogoPreview(ev.target.result);
        setForm({ ...form, logo: ev.target.result });
      };
      reader.readAsDataURL(files[0]);
    } else {
      setForm({ ...form, [name]: value });
    }
  };

  const handleAdd = async () => {
    if (!form.nombre || !form.totalBoxeadores || !form.ubicacion) return;
  
    const nuevoGimnasio = {
      name: form.nombre,
      size: form.tamano,
      totalBoxers: Number(form.totalBoxeadores),
      location: form.ubicacion,
      imageUrl: form.logo || '',
    };
  
    try {
      const res = await fetch(API_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(nuevoGimnasio),
      });
  
      const result = await res.json().catch(() => ({}));
  
      if (!res.ok) {
        console.error('Error del servidor:', res.status, result);
      } else {
        const nuevoAdaptado = {
          id: result.id,
          nombre: result.name,
          tamano: result.size,
          totalBoxeadores: result.totalBoxers,
          ubicacion: result.location,
          logo: result.imageUrl,
        };
        setGyms((prev) => [...prev, nuevoAdaptado]);
        resetForm();
      }
    } catch (error) {
      console.error('Error al agregar gimnasio:', error);
    }
  };

  const handleDelete = async (id) => {
    try {
      const res = await fetch(`${API_URL}/${id}`, {
        method: 'DELETE',
      });
      if (res.ok) {
        setGyms((prev) => prev.filter((g) => g.id !== id));
      }
    } catch (error) {
      console.error('Error al eliminar gimnasio:', error);
    }
  };

  const handleEdit = (gym) => {
    setEditId(gym.id);
    setForm({
      nombre: gym.nombre,
      tamano: gym.tamano,
      totalBoxeadores: gym.totalBoxeadores,
      ubicacion: gym.ubicacion,
      logo: gym.logo || '',
    });
    setLogoPreview(gym.logo || '');
  };

  const handleUpdate = async () => {
    const actualizado = {
      name: form.nombre,
      size: form.tamano,
      totalBoxers: Number(form.totalBoxeadores),
      location: form.ubicacion,
      imageUrl: form.logo || '',
    };
  
    try {
      const res = await fetch(`${API_URL}/${editId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(actualizado),
      });
  
      const result = await res.json().catch(() => ({}));
  
      if (res.ok) {
        setGyms((prev) =>
          prev.map((g) =>
            g.id === editId
              ? {
                  ...g,
                  nombre: actualizado.name,
                  tamano: actualizado.size,
                  totalBoxeadores: actualizado.totalBoxers,
                  ubicacion: actualizado.location,
                  logo: actualizado.imageUrl,
                }
              : g
          )
        );
        resetForm();
        setEditId(null);
      } else {
        console.error('Error al actualizar:', res.status);
      }
    } catch (error) {
      console.error('Error al actualizar gimnasio:', error);
    }
  };

  const resetForm = () => {
    setForm({ nombre: '', tamano: 'pequeño', totalBoxeadores: '', ubicacion: '', logo: '' });
    setLogoPreview('');
  };

  return (
    <div className="App matte-bg">
      <Navbar />
      <div className="main-content">
        <h1 className="gym-title">Gestión de Gimnasios</h1>
        <div className="gym-form">
          <input name="nombre" placeholder="Nombre del gimnasio" value={form.nombre} onChange={handleChange} />
          <select name="tamano" value={form.tamano} onChange={handleChange}>
            <option value="pequeño">Pequeño</option>
            <option value="mediano">Mediano</option>
            <option value="grande">Grande</option>
          </select>
          <input name="totalBoxeadores" type="number" placeholder="Total de boxeadores" value={form.totalBoxeadores} onChange={handleChange} />
          <input name="ubicacion" placeholder="Ubicación" value={form.ubicacion} onChange={handleChange} />
          <input name="logo" type="file" accept="image/*" onChange={handleChange} />
          {logoPreview && <img src={logoPreview} alt="Logo preview" className="logo-preview" />}
          {editId ? (
            <button onClick={handleUpdate}>Modificar</button>
          ) : (
            <button onClick={handleAdd}>Agregar</button>
          )}
        </div>

        <div className="gym-cards-container">
          {gyms.map((gym) => (
            <div className="gym-card" key={gym.id}>
              <div className="gym-card-logo-wrap">
                {gym.logo ? (
                  <img src={gym.logo} alt="Logo" className="gym-card-logo" />
                ) : (
                  <div className="gym-card-logo gym-card-logo-placeholder"></div>
                )}
              </div>
              <div className="gym-card-info-exact">
                <div className="gym-card-name-exact">{gym.nombre}</div>
                <div className="gym-card-row-exact"><b><span className="label-red">Tamaño:</span></b> <span>{gym.tamano}</span></div>
                <div className="gym-card-row-exact"><b><span className="label-red">Total de boxeadores:</span></b> <span>{gym.totalBoxeadores}</span></div>
                <div className="gym-card-row-exact"><b><span className="label-red">Ubicación:</span></b> <span>{gym.ubicacion}</span></div>
              </div>
              <div className="gym-card-actions-exact">
                <button className="btn-modificar" onClick={() => handleEdit(gym)}>modificar</button>
                <button className="btn-quitar" onClick={() => handleDelete(gym.id)}>quitar</button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default App;